import { Tabs } from '@ayble-health/dashboard-components';
import React, { useState } from 'react';
import { Box } from '@chakra-ui/react';
import { AppointmentsPage } from '../AppointmentsPage/AppointmentsPage';
import { OverviewPage } from './overview/OverviewPage';
import { ProgressPage } from '../ProgressPage/ProgressPage';
import LabsDocumentsPage from './overview/LabsDocumentsPage';
import PharmacyPage from './overview/PharmacyPage';
import { ProviderType } from '../../api/types';

const APPOINTMENTS_TAB_INDEX = 2;

export const UserDashboardMainContent = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [requestedProviderType, setRequestedProviderType] =
    useState<ProviderType | null>(null);

  const handleTabChange = (index: number) => {
    setActiveIndex(index);

    if (index !== APPOINTMENTS_TAB_INDEX) {
      setRequestedProviderType(null);
    }
  };

  const openAppointments = (providerType?: ProviderType) => {
    setRequestedProviderType(providerType ?? null);
    setActiveIndex(APPOINTMENTS_TAB_INDEX);
  };

  return (
    <Box mt={3}>
      <Tabs
        activeIndex={activeIndex}
        setActiveIndex={handleTabChange}
        tabs={[
          {
            label: 'Overview',
            content: (
              <OverviewPage
                onOpenAppointments={openAppointments}
                setActiveIndex={setActiveIndex}
              />
            ),
          },
          { label: 'Progress', content: <ProgressPage /> },
          {
            label: 'Appointments',
            content: (
              <AppointmentsPage
                requestedProviderType={requestedProviderType}
                onRequestedProviderTypeHandled={() =>
                  setRequestedProviderType(null)
                }
              />
            ),
          },
          { label: 'Pharmacy', content: <PharmacyPage /> },
          { label: 'Labs & Documents', content: <LabsDocumentsPage /> },
        ]}
      />
    </Box>
  );
};
